export default __webpack_public_path__ + "static/media/members-benefit.715a03d0.svg";